import React from 'react'

export const Home = () => {
    const brands = [
        'BigBasket',
        'Reliance Fresh',
        'More',
        'DMart',
        "Spencer's",
        "Nature’s Basket",
        'Zomato',
        'Zepto',
    ];
    const fruits = [
        {
            title: 'Mangoes',
            icon: 'bi-emoji-sunglasses',
            desc: 'Alphonso, Kesar, Badami, Totapuri, Langra, Himsagar. Season: Mar–Jul',
            link: 'View grades →',
        },
        {
            title: 'Citrus',
            icon: 'bi-droplet',
            desc: 'Nagpur oranges, Kinnow, Mosambi, Galgal. Seedless, export grade.',
            link: 'View specs →',
        },
        {
            title: 'Grapes',
            icon: 'bi-cup-straw',
            desc: 'Thompson Seedless, Sonaka, Sharad Seedless. APEDA export certified.',
            link: 'Export docs →',
        },
        {
            title: 'Exotic & specialty',
            icon: 'bi-flower1',
            desc: 'Dragon fruit, avocado, pomegranate, custard apple, jackfruit.',
            link: 'Seasonal →',
        },
    ];
    const products = [
        {
            name: 'Alphonso mango',
            img: 'p4.jfif',
            badge: 'HAP certified',
            desc: 'Ratnagiri · Organic · 12 pcs box',

            fob: 'FOB Mumbai',
        },
        {
            name: 'Nagpur oranges',
            img: 'p1.jpg',
            desc: 'Vidarbha · AGMARK · 72 count',

            fob: 'FOB Nhava Sheva',
        },
        {
            name: 'Dragon fruit',
            img: 'p3.jfif',
            desc: 'Karnataka · Premium · 9–12 pcs',

            fob: 'FOB Bangalore',
        },
        {
            name: 'Pomegranate',
            img: 'p2.jfif',
            desc: 'Solapur · Bhagwa · 6 pcs box',

            fob: 'FOB Mumbai',
        },
    ];
    return (
        <>
            <section className="py-5 ">
                <div className="container">

                    {/* HEADER */}
                    <div className="d-flex justify-content-between align-items-end mb-5 flex-wrap gap-3">
                        <div>
                            <span className="badge bg-dark text-white px-3 py-2 fw-semibold">
                                <i className="bi bi-star-fill text-warning me-2" />
                                CURRENT OFFERINGS · EXPORT QUALITY
                            </span>

                            <h2 className="display-6 fw-bold mt-3 text-dark">
                                Available Fresh Produce
                            </h2>

                            <p className="text-muted mb-0">
                                Premium Indian fruits ready for international shipment
                            </p>
                        </div>

                        <a
                            href="/produce"
                            className="btn btn-success px-4 py-2 fw-semibold d-none d-md-inline-flex align-items-center"
                            style={{ borderRadius: "8px" }}
                        >
                            View All Products <i className="bi bi-arrow-right ms-2" />
                        </a>
                    </div>

                    {/* CARDS */}
                    <div className="row g-4">
                        {products.map((item) => (
                            <div className="col-lg-3 col-md-6" key={item.name}>
                                <div
                                    className="card h-100 border-0 shadow-sm"
                                    style={{ borderRadius: "16px", transition: "0.3s" }}
                                >
                                    <img
                                        src={item.img}
                                        alt={item.name}
                                        className="card-img-top"
                                        style={{
                                            height: 220,
                                            objectFit: "cover",
                                            borderTopLeftRadius: "16px",
                                            borderTopRightRadius: "16px",
                                        }}
                                    />

                                    <div className="card-body p-4 d-flex flex-column">

                                        {/* Title + Badge */}
                                        <div className="d-flex justify-content-between align-items-start">
                                            <h5 className="fw-bold mb-1">{item.name}</h5>
                                            {item.badge && (
                                                <span
                                                    className="badge bg-success bg-opacity-10 text-success fw-semibold"
                                                    style={{ fontSize: "0.75rem" }}
                                                >
                                                    {item.badge}
                                                </span>
                                            )}
                                        </div>

                                        <p className="text-secondary small mt-2 flex-grow-1">
                                            {item.desc}
                                        </p>

                                        {/* FOB Info */}
                                        {item.fob && (
                                            <div className="mb-3">
                                                <small className="text-muted">
                                                    <i className="bi bi-truck me-1" />
                                                    {item.fob}
                                                </small>
                                            </div>
                                        )}

                                        {/* CTA */}
                                        <a
                                            href="#"
                                            className="btn btn-outline-success w-100 fw-semibold"
                                            style={{ borderRadius: "10px" }}
                                        >
                                            Request Export Quote
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* MOBILE CTA */}
                    <div className="text-center mt-5 d-md-none">
                        <a
                            href="#"
                            className="btn btn-success px-5 py-2 fw-semibold"
                            style={{ borderRadius: "8px" }}
                        >
                            View All Products
                        </a>
                    </div>
                </div>
            </section>


            <section
                className="py-5"
                style={{ backgroundColor: "var(--color-bg)" }}
            >
                <div className="container">

                    {/* HEADER */}
                    <div className="text-center mb-5">
                        <span
                            className="px-4 py-2 fw-semibold d-inline-block"
                            style={{
                                backgroundColor: "var(--color-success)",
                                color: "#fff",
                                borderRadius: "8px",
                                letterSpacing: "1px"
                            }}
                        >
                            <i className="bi bi-grid me-2" />
                            PREMIUM INDIAN FRUITS
                        </span>

                        <h2
                            className="display-6 fw-bold mt-4"
                            style={{ color: "var(--color-text-primary)" }}
                        >
                            Export-Grade Fruit Varieties
                        </h2>

                        <p
                            className="fs-5 col-lg-7 mx-auto"
                            style={{ color: "var(--color-text-secondary)" }}
                        >
                            Carefully sourced from India’s most renowned fruit-growing regions —
                            ensuring superior taste, size, and shelf life for global markets.
                        </p>
                    </div>

                    {/* CARDS */}
                    <div className="row g-4">
                        {fruits.map((item) => (
                            <div className="col-md-6 col-lg-3" key={item.title}>
                                <div
                                    className="card border-0 shadow-sm h-100"
                                    style={{
                                        borderRadius: "16px",
                                        overflow: "hidden",
                                        transition: "0.3s"
                                    }}
                                >

                                    {/* Optional Image */}
                                    {item.img && (
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                            className="card-img-top"
                                            style={{
                                                height: "200px",
                                                objectFit: "cover"
                                            }}
                                        />
                                    )}

                                    <div className="card-body p-4 d-flex flex-column">

                                        {/* Icon */}
                                        <div
                                            className="mb-3 d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "12px",
                                                backgroundColor: "rgba(34,197,94,0.1)"
                                            }}
                                        >
                                            <i
                                                className={`bi ${item.icon} fs-4`}
                                                style={{ color: "var(--color-success)" }}
                                            />
                                        </div>

                                        {/* Title */}
                                        <h5
                                            className="fw-bold mb-2"
                                            style={{ color: "var(--color-text-primary)" }}
                                        >
                                            {item.title}
                                        </h5>

                                        {/* Description */}
                                        <p
                                            className="small flex-grow-1"
                                            style={{ color: "var(--color-text-secondary)" }}
                                        >
                                            {item.desc}
                                        </p>

                                        {/* CTA */}
                                        <a
                                            href="#"
                                            className="fw-semibold text-decoration-none mt-2"
                                            style={{ color: "var(--color-success)" }}
                                        >
                                            {item.link} →
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        {/* LEFT CONTENT */}
                        <div className="col-lg-6">
                            <span
                                className="px-4 py-2 fw-semibold fs-6 rounded-0 d-inline-block"
                                style={{
                                    backgroundColor: 'rgba(34,197,94,0.1)',
                                    color: 'var(--color-success)',
                                }}
                            >
                                <i className="bi bi-shield-check me-2" />
                                FARMER PARTNERSHIPS
                            </span>

                            <h2
                                className="display-6 fw-bold mt-4 mb-4"
                                style={{ color: 'var(--color-text-primary)' }}
                            >
                                Direct from 200+ Indian farms.
                                <br />
                                No middlemen. Full traceability.
                            </h2>

                            <p
                                className="fs-5 mb-4"
                                style={{ color: 'var(--color-text-secondary)' }}
                            >
                                We work directly with farmer producer organisations (FPOs) in
                                Maharashtra, Gujarat, Karnataka, and Himachal. Our quality team
                                conducts on-field inspections and lab testing for every batch.
                            </p>

                            <div className="vstack gap-3">
                                {[
                                    [
                                        'On-ground QC',
                                        'Inspectors in Nashik, Ratnagiri, Nagpur, Coorg',
                                    ],
                                    [
                                        'Food safety',
                                        'FSSAI, AGMARK, GLOBALG.A.P. certified packhouses',
                                    ],
                                    [
                                        'Flexible volumes',
                                        '5 kg samples to full container loads',
                                    ],
                                ].map(([title, desc]) => (
                                    <div className="d-flex" key={title}>
                                        <i
                                            className="bi bi-check-circle-fill fs-5 me-3"
                                            style={{ color: 'var(--color-success)' }}
                                        />
                                        <div>
                                            <span className="fw-bold">{title}</span> – {desc}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <a
                                href="#"
                                className="btn rounded-0 px-5 py-3 mt-5 fw-semibold"
                                style={{
                                    backgroundColor: 'var(--color-success)',
                                    color: '#fff',
                                }}
                            >
                                <i className="bi bi-file-earmark-text me-2" />
                                Download FPO partnership guide
                            </a>
                        </div>

                        {/* RIGHT TESTIMONIAL */}
                        <div className="col-lg-6">
                            <div
                                className="p-5"
                                style={{
                                    backgroundColor: 'var(--color-text-primary)',
                                    color: '#fff',
                                }}
                            >
                                <span
                                    className="fw-bold fs-1"
                                    style={{ color: 'var(--color-warning)' }}
                                >
                                    &quot;
                                </span>

                                <p className="fs-4 fw-light lh-base">
                                    Falwala has been our exclusive export partner for 8 years. Their
                                    understanding of Indian fruit quality and international
                                    standards is exceptional.
                                </p>

                                <div className="d-flex align-items-center mt-4">
                                    <div
                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                        style={{
                                            width: 60,
                                            height: 60,
                                            backgroundColor: 'var(--color-surface)',
                                            color: 'var(--color-text-primary)',
                                        }}
                                    >
                                        <span className="fw-bold fs-4">RJ</span>
                                    </div>

                                    <div className="ms-3">
                                        <span className="fw-bold">Rajesh Joshi</span>
                                        <span
                                            className="d-block small"
                                            style={{ color: 'rgba(255,255,255,0.6)' }}
                                        >
                                            Procurement Director, BigBasket
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section
                className="py-5"
                style={{ backgroundColor: 'var(--color-bg)' }}
            >
                <div className="container">
                    {/* HEADER */}
                    <div className="text-center mb-4">
                        <span
                            className="d-inline-block px-4 py-2 fw-semibold fs-6"
                            style={{
                                backgroundColor: 'var(--color-surface)',
                                color: 'var(--color-text-primary)',
                                border: '1px solid var(--color-success)',
                            }}
                        >
                            Trusted by India&apos;s leading retailers
                        </span>
                    </div>

                    {/* CAROUSEL */}
                    <div
                        id="trustCarousel"
                        className="carousel slide"
                        data-bs-ride="carousel"
                        data-bs-interval="2000"
                        data-bs-touch="true"
                    >
                        <div className="carousel-inner">
                            {[0, 1].map((slideIndex) => (
                                <div
                                    key={slideIndex}
                                    className={`carousel-item ${slideIndex === 0 ? 'active' : ''}`}
                                >
                                    <div className="d-flex justify-content-center align-items-center gap-4 gap-lg-5 flex-wrap">
                                        {brands.map((brand) => (
                                            <div
                                                key={`${brand}-${slideIndex}`}
                                                className="px-4 py-3 fw-bold fs-5 shadow-sm text-center"
                                                style={{
                                                    backgroundColor: 'var(--color-surface)',
                                                    color: 'var(--color-text-secondary)',
                                                    minWidth: 160,
                                                }}
                                            >
                                                {brand}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* FOOT NOTE */}
                    <div className="text-center mt-4">
                        <span
                            className="small fw-semibold"
                            style={{ color: 'var(--color-success)' }}
                        >
                            Powering organised retail, quick commerce & exports nationwide
                        </span>
                    </div>
                </div>
            </section>


            <section
                className="py-5"
                style={{
                    backgroundColor: 'var(--color-text-primary)',
                    color: '#fff',
                }}
            >
                <div className="container">
                    <div className="row align-items-center">
                        {/* LEFT CONTENT */}
                        <div className="col-lg-6">
                            <h2 className="display-6 fw-bold mb-3">
                                Discuss your wholesale requirements
                            </h2>

                            <p
                                className="fs-5 mb-4"
                                style={{ color: 'rgba(255,255,255,0.7)' }}
                            >
                                Our trade team responds within 2 hours. Inquiries for mangoes,
                                citrus, grapes, and specialty Indian fruits.
                            </p>

                            <div className="d-flex gap-4 flex-wrap">
                                <div>
                                    <i
                                        className="bi bi-telephone-fill fs-4"
                                        style={{ color: 'var(--color-success)' }}
                                    />
                                    <p className="mt-2 fw-bold mb-0">+91 9431812596</p>
                                    <span
                                        className="small"
                                        style={{ color: 'rgba(255,255,255,0.6)' }}
                                    >
                                        Procurement helpline
                                    </span>
                                </div>

                                <div>
                                    <i
                                        className="bi bi-envelope-fill fs-4"
                                        style={{ color: 'var(--color-success)' }}
                                    />
                                    <p className="mt-2 fw-bold mb-0">hindustanfruits@yahoo.co.in</p>
                                    <span
                                        className="small"
                                        style={{ color: 'rgba(255,255,255,0.6)' }}
                                    >
                                        reply within 1 hour
                                    </span>
                                </div>
                            </div>

                            <div className="mt-4">
                                <span
                                    className="badge rounded-0 px-3 py-2"
                                    style={{
                                        backgroundColor: 'var(--color-warning)',
                                        color: 'var(--color-text-primary)',
                                    }}
                                >
                                    📌 Head office: Sarkari Bazar, Chapra – 841301 (Bihar)
                                </span>

                                {/* <span
                                    className="badge rounded-0 px-3 py-2 ms-2"
                                    style={{
                                        backgroundColor: 'var(--color-success)',
                                        color: '#fff',
                                    }}
                                >
                                    📦 Packhouses: Shop No.: 11
                                    Bazar Samiti Yard Sandha
                                    Chapra – 841301 (Bihar)
                                </span> */}
                            </div>
                        </div>

                        {/* RIGHT FORM */}
                        <div className="col-lg-6 mt-4 mt-lg-0">
                            <div
                                className="p-5"
                                style={{ backgroundColor: 'var(--color-surface)' }}
                            >
                                <h5
                                    className="fw-bold mb-4"
                                    style={{ color: 'var(--color-text-primary)' }}
                                >
                                    Request a quote
                                </h5>

                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                className="form-control rounded-0 border-0 border-bottom"
                                                placeholder="Full name"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                className="form-control rounded-0 border-0 border-bottom"
                                                placeholder="Company / firm"
                                            />
                                        </div>

                                        <div className="col-12">
                                            <input
                                                type="email"
                                                className="form-control rounded-0 border-0 border-bottom"
                                                placeholder="Business email"
                                            />
                                        </div>

                                        <div className="col-12">
                                            <textarea
                                                className="form-control rounded-0 border-0 border-bottom"
                                                rows="2"
                                                placeholder="Products / volume / destination / export or domestic"
                                            />
                                        </div>

                                        <div className="col-12 mt-4">
                                            <button
                                                type="submit"
                                                className="btn w-100 rounded-0 py-3 fw-semibold"
                                                style={{
                                                    backgroundColor: 'var(--color-success)',
                                                    color: '#fff',
                                                }}
                                            >
                                                Submit inquiry
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <p
                                    className="small mt-3 mb-0"
                                    style={{ color: 'var(--color-text-secondary)' }}
                                >
                                    <i className="bi bi-shield-check me-1" />
                                    FSSAI · APEDA · GST ready invoices
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
